export default __webpack_public_path__ + "_/images/app/android/android-ru-4-ecbd921f65ea8cd83ce40b7e0402c3128bc13c84ad181a62190e1bc26f18ddf6.png";